export const projectsList = [
  {
    title: "JamLive Platform",
    description:
      "Real-time harmony for real-life musicians - lyrics, chords, and roles in perfect sync.",
    imgSrc:
      "https://github.com/segevGr/JamLive/blob/master/screenshots/admin-lobby-live-song.png?raw=true",
    link: "https://jamlive.vercel.app/",
    github: "https://github.com/segevGr/JamLive",
    tech: ["React", "NestJS", "MongoDB", "Socket.io", "Docker"],
  },
  {
    title: "Portfolio Website",
    description:
      "My personal landing page showcasing my skills and achievements.",
    imgSrc:
      "https://github.com/segevGr/portfolio-web/blob/main/public/screenshots/hero.png?raw=true",
    link: "https://segevgr.github.io/portfolio-web/",
    github: "https://github.com/segevGr/portfolio-web",
    tech: ["React", "TailwindCSS"],
  },
];
